import { FC, Dispatch, SetStateAction } from 'react'
import {
  DefaultTitle, 
  DefaultSubtitle, 
  RadioButtonsContainer, 
  ApplicationMethodPDFReminderContainer 
} from '../../../components/application/defaultComponents'
import ImgRadio from '../../../components/basic/ImgRadio'
import ReminderCard from '../../../components/basic/ReminderCard'

import OnlineFormImg from '../../../assets/applicationFormsImgs/onlineform.svg'
import DownloadPdfImg from '../../../assets/applicationFormsImgs/downloadpdf.svg'

interface ApplicationTypeProps {
  applicationMethod: string; 
  setApplicationMethod: Dispatch<SetStateAction<string>>
}

const ApplicationType: FC<ApplicationTypeProps> = ({ applicationMethod, setApplicationMethod }) => {
  return (
    <>
      <DefaultTitle>You are about to begin your online application:</DefaultTitle>
      <br/><br/>
      <RadioButtonsContainer style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <ImgRadio 
          value="ONLINE" 
          onChange={e => setApplicationMethod(e.target.value)} 
          checked={applicationMethod === 'ONLINE'}
          label="Online"
        >
          <img src={OnlineFormImg} alt="online" />
        </ImgRadio>
      </RadioButtonsContainer>
      <br/><br/>
      <DefaultSubtitle>
        <u>Alternatively</u>, you can complete a fillable PDF version of the <a href={'https://e1.nmcdn.io/assets/tlie/wp-content/uploads/2025/07/FINAL-New-Business-Application-2.pdf'} target={'_blank'}>new business</a> application 
        and email it directly to <a href={'mailto:app@tlie.org'}>app@tlie.org</a>, but please note that this processing will take more time and the
        online application is strongly recommended.
      </DefaultSubtitle>
      {applicationMethod === 'PDF' ? (
        <ApplicationMethodPDFReminderContainer>
          <ReminderCard
            icon='bulb'
            withLeftBar
            title='Downloading a PDF may take longer'
          >
            Our customers who use the online application typically fill out the form faster and more accurately.
          </ReminderCard>
        </ApplicationMethodPDFReminderContainer>
      ) : null}
    </>
  )
}

export default ApplicationType